export default "__VITE_ASSET__2615ea19__"